import { getCookie, setCookie } from "./utilities";
import { gsap } from "gsap";

export const homePagePreloader = () => {
	const homePage = document.querySelector('#js__body.home.page-template-default');
	if (homePage) {
		const homePageCookieAlreadySet = getCookie('home-preloader');

		if ( homePageCookieAlreadySet ) {
			homePagePreloaderComplete();
		} else {
            document.addEventListener("DOMContentLoaded", function () {
                const progressTextHundreds = document.querySelector('.js-preloader-percent-hundreds');
                const progressTextTens = document.querySelector('.js-preloader-percent-tens');
                const progressTextSingle = document.querySelector('.js-preloader-percent-single');
                const progressTextPercent = document.querySelector('.js-preloader-percent');
                const progressBar = document.querySelector('.js-preloader-progress');
                const loadingStages = Math.round(gsap.utils.random(3, 5, 1));
                let progressVal = 0;

                // Create the timeline
                let tl = gsap.timeline({
                    onComplete: () => {
                        setCookie('home-preloader', true, 1); // Only show preloader animation once a day
                        homePagePreloaderComplete();
                    }
                });

                // Add the loading stages to the timelime
                for (let index = 1; index <= loadingStages; index++) {
                    const stagePercent = Math.round((100 / loadingStages) * index);
                    const duration = gsap.utils.random(0.5, 0.75, 0.01);
                    const delay = index === 1 ? 0 : gsap.utils.random(0, 0.4, 0.01);

                    // Update the progress text
                    tl.to({ val: progressVal }, {
                        delay: delay,
                        duration: duration,
                        val: stagePercent,
                        roundProps: "val",
                        onUpdate: function() {
                            const currentValue = Math.round(this.targets()[0].val);
                            const hundredsValue = Math.floor(currentValue / 100);
                            const tensValue = Math.floor((currentValue % 100) / 10);
                            const singleValue = currentValue % 10;
                
                            progressTextHundreds.textContent = hundredsValue > 0 ? hundredsValue : '';
                            progressTextTens.textContent = hundredsValue === 0 && tensValue === 0 ? '' : tensValue;
                            progressTextSingle.textContent = singleValue;
                        },
                        ease: "none"
                    }, 'loading' + index);

                    // Update the progress bar
                    tl.to(progressBar, {
                        delay: delay,
                        duration: duration,
                        x: () => 0 - (100 - stagePercent) + '%',
                        ease: 'linear'
                    }, 'loading' + index);

                    // Update the progress val to be the stagePercent
                    progressVal = stagePercent;

                    // loading has completed so finish the timeline animation
                    if (index === loadingStages) {
                        const preloaderBg = document.querySelector('.js-preloader-bg');

                        // Hide the progress bar
                        tl.to(progressBar, {
                            duration: 0.1,
                            autoAlpha: 0
                        }, 'stage2');

                        // Change the background color to red
                        tl.to(preloaderBg, {
                            duration: 0.1,
                            backgroundColor: '#C4242D'
                        }, 'stage2');

                        // Slide the background off screen
                        tl.to(preloaderBg, {
                            delay: 0.1,
                            duration: 0.4,
                            y: '-100%',
                            ease: 'linear'
                        }, 'stage3');

                        // Slide the progress text items closed
                        tl.to([progressTextHundreds, progressTextTens, progressTextSingle, progressTextPercent], {
                            duration: 0.35,
                            x: '-100%',
                            ease: 'linear'
                        }, 'stage4');
                        
                        // Fade in hero module elems if module 1
                        const firstModule = document.querySelector('.module__1');
                        
                        if ( firstModule.classList.contains('m__hero') ) {
                            const overlay = firstModule.querySelector('.m__hero__overlay');
                            const explore = firstModule.querySelector('.m__hero__explore');
                            const elems = [overlay];

                            if ( explore ) {
                                elems.push(explore);
                            }

                            tl.fromTo(elems, {
                                autoAlpha: 0
                            }, {
                                delay: 0.15,
                                duration: 0.4,
                                autoAlpha: 1
                            }, 'stage5');
                        }
                    }
                }
            });
		}	
	}
} 

const homePagePreloaderComplete = () => {
	const preloader = document.querySelector('.js-preloader');

	if ( preloader ) {
		preloader.classList.add('hidden');
		document.querySelector('#js__body.home.page-template-default').classList.remove('preloading');
		document.querySelector('body').classList.remove('preloading');
	}
}